import { ApiCategory } from '@/components/personalizedCategoryCarousel/apiCategories'

/**
 * Per-category "magic number" of unique bidders a listing needs to hit,
 * per the Q3 competition deck (slide 8): cell phones 5, apparel 5,
 * electronics 7. Keyed by the same top-level `ApiCategory` the search API's
 * `categories` filter and `AllListingsListing.categories` already use, so no
 * separate category taxonomy is introduced.
 */
const MAGIC_NUMBERS: Partial<Record<ApiCategory, number>> = {
  [ApiCategory.CellPhones]: 5,
  [ApiCategory.ApparelShoesAndAccessories]: 5,
  [ApiCategory.Electronics]: 7,
}

export const DEFAULT_MAGIC_NUMBER = 5

export const getMagicNumber = (
  category: ApiCategory | null | undefined
): number => (category && MAGIC_NUMBERS[category]) ?? DEFAULT_MAGIC_NUMBER

/**
 * Seller exclusions: structure only, ships empty.
 *
 * The Q3 deck's exclusion shorthand (cell phones: SMSG, STONE, LOOP, ROYAL,
 * PROSRVC; electronics: those + BBY; apparel: BRISCO, GETLIVE, HARMON,
 * ROYAL) has not been verified against real seller/storefront identifiers or
 * against the Tableau workbook's actual exclusion semantics — do not
 * populate until both are confirmed with the deck owner. Keyed by
 * `storefrontName` (the closest existing search-result field to the slide
 * shorthand). Populating a category's list later is a one-line change here;
 * no engine changes required.
 */
export const SELLER_EXCLUSIONS: Partial<Record<ApiCategory, string[]>> = {
  [ApiCategory.CellPhones]: [],
  [ApiCategory.ApparelShoesAndAccessories]: [],
  [ApiCategory.Electronics]: [],
}
